import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=a10d3722&scoped=true&"
import script from "./Chat.vue?vue&type=script&lang=js&"
export * from "./Chat.vue?vue&type=script&lang=js&"
import style0 from "./Chat.vue?vue&type=style&index=0&id=a10d3722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10d3722",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a10d3722')) {
      api.createRecord('a10d3722', component.options)
    } else {
      api.reload('a10d3722', component.options)
    }
    module.hot.accept("./Chat.vue?vue&type=template&id=a10d3722&scoped=true&", function () {
      api.rerender('a10d3722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/Chat.vue"
export default component.exports